import { Modal, Select, Table, Typography } from "antd";
import { ColumnType } from "antd/es/table";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCreateCompany, useDeleteCompany } from "../../../api/company";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as CloseIcon } from "../../../common/images/svg/CloseIcon.svg";
import { ReactComponent as PencilIcon } from "../../../common/images/svg/PencilSimpleLine.svg";
import { ReactComponent as PlusIcon } from "../../../common/images/svg/Plus.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";
import { ReactComponent as TrashIcon } from "../../../common/images/svg/Trash.svg";
import { ReactComponent as ClearIcon } from "../../../common/images/svg/XCircle.svg";
import CustomBreadCrumb from "../../../components/breadCrumb/breadCrumb";
import { CustomButton } from "../../../components/button/buttonCustom";
import { SearchCustom } from "../../../components/inputs/search/searchCustom";
import ConfirmModal from "../../../components/modal/confirmModal";
import NextPagination from "../../../components/pagination/next";
import PrevPagination from "../../../components/pagination/prev";
import { useNotification } from "../../../components/providers/notification/useNotification";
import { setTitleHeader } from "../../../store/use-title-header-store";
import { useCompany } from "../../../utils/hooks/useCompany";
import { useMetadataCountries } from "../../../utils/hooks/useMetadataCountries";
import { useMetadataCurrency } from "../../../utils/hooks/useMetadataCurrency";
import useResponsive from "../../../utils/hooks/useResponsive";
import { Row as RowTable } from "../../components/interface";
import { BankBeneficiary, InfoBeneficiary, WalletBeneficiary } from "../type";
import "./benificiary.css";
import "./custom-ant-table.css";
import FormBank from "./modal-add-new/new-payee/form-bank";
import FormConfirm from "./modal-add-new/new-payee/form-confirm";
import FormInfo from "./modal-add-new/new-payee/form-info";
import FormWallet from "./modal-add-new/new-payee/form-wallet";
import TitleModal from "./modal-add-new/new-payee/title-modal";
import FormAddNewRemitter from "./modal-add-new/new-remitter/form-add-new";

const breadCrumb = [
  {
    name: "Portfolio",
    path: "/",
  },
  {
    name: "Beneficiaries & Remitters",
    path: "/beneficiaries",
  },
];

export const listStep = [
  { name: "Info", step: 1 },
  { name: "Wallet", step: 2 },
  { name: "Bank ", step: 3 },
  { name: "Confirm", step: 4 },
];

const start = 0;
const end = 20;

export const ThemedBenificiaryRemitterPage: React.FC<any> = () => {
  const navigate = useNavigate();
  const { isTablet } = useResponsive();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const show = queryParams.get("show");

  const [stepNewBeneficiary, setStepNewBeneficiary] = useState<number | null>(
    null
  );
  const [params, setParams] = useState({ start, end });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState<string>("");
  const [searchCountry, setSearchCountry] = useState<string>("");
  const [bankSelected, setBankSelected] = useState<any>();
  const [deleteBeneficiaryId, setDeleteBeneficiaryId] = useState<number | null>(
    null
  );
  const [modalRemitter, setModalRemitter] = useState<boolean>(false);
  const [walletSkip, setWalletSkip] = useState<boolean>(false);
  const [bankSkip, setBankSkip] = useState<boolean>(false);
  const [valueFormInfo, setValueFormInfo] = useState<InfoBeneficiary>();
  const [valueFormWallet, setValueFormWallet] = useState<
    WalletBeneficiary | undefined
  >();

  const [valueFormBank, setValueFormBank] = useState<
    BankBeneficiary | undefined
  >();
  const [infoByUserCode, setInfoByUserCode] = useState<any>(null);
  const [infoByUserCodeRemitter, setInfoByUserCodeRemitter] =
    useState<any>(null);

  const { open: openNotification } = useNotification();

  const { metadataCountries } = useMetadataCountries();
  const { metadataCurrency } = useMetadataCurrency();

  const { dataListCompany, refetch, isLoading } = useCompany(
    params,
    searchName,
    searchCountry
  );

  const { mutate: createCompany, isLoading: loadingCreateCompany } =
    useCreateCompany({
      onSuccess: (response: { data: { message: string } }) => {
        if (openNotification) {
          openNotification({
            key: "create_success",
            message:
              response.data.message || "Create Beneficiary successfully!",
            type: "success",
          });
        }
        setValueFormInfo(undefined);
        setValueFormWallet(undefined);
        setValueFormBank(undefined);
        setStepNewBeneficiary(null);
        setBankSelected(null);
        setWalletSkip(false);
        setBankSkip(false);
        refetch();
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "create_failed",
            message: error.message || "Create Beneficiary failed!",
            type: "error",
          });
        }
      },
    });

  const { mutate: createRemitter, isLoading: loadingCreateRemitter } =
    useCreateCompany({
      onSuccess: (response: { data: { message: string } }) => {
        if (openNotification) {
          openNotification({
            key: "create_success",
            message: response.data.message || "Create Remitter successfully!",
            type: "success",
          });
        }
        setModalRemitter(false);
        refetch();
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "create_failed",
            message: error.message || "Create Remitter failed!",
            type: "error",
          });
        }
      },
    });

  const { mutate: deleteCompany, isLoading: loadingDelete } = useDeleteCompany({
    onSuccess: (response: { data: { message: string } }) => {
      if (openNotification) {
        openNotification({
          key: "delete_success",
          message:
            response.data.message ||
            "Delete Beneficiary & Remitter successfully!",
          type: "success",
        });
      }
      setDeleteBeneficiaryId(null);
      refetch();
    },
    onError: (error: { message: string }) => {
      if (openNotification) {
        openNotification({
          key: "delete_failed",
          message: error.message || "Delete Beneficiary & Remitter failed!",
          type: "error",
        });
      }
    },
  });

  const handleCloseModalBeneficiary = () => {
    if (loadingCreateCompany) return;
    setValueFormInfo(undefined);
    setValueFormWallet(undefined);
    setValueFormBank(undefined);
    setStepNewBeneficiary(null);
    setBankSelected(null);
    setWalletSkip(false);
    setBankSkip(false);
    navigate("/beneficiaries", { replace: true });
    setInfoByUserCode(null);
  };

  const handleCloseModalRemitter = () => {
    if (loadingCreateRemitter) return;
    setModalRemitter(false);
    setInfoByUserCodeRemitter(null);
  };

  const handleSearch = (value: string) => {
    setSearchName(value);
    setCurrentPage(1)
    setParams({ ...params, start, end })
  };

  const handleStep = (step: number) => {
    if (loadingCreateCompany) return;
    setStepNewBeneficiary(step);
  };

  const handleBack = () => {
    if (loadingCreateCompany) return;
    if (!stepNewBeneficiary) return;
    setStepNewBeneficiary(stepNewBeneficiary - 1);
  };

  const handleSkip = () => {
    if (loadingCreateCompany) return;
    if (!stepNewBeneficiary) return;
    setStepNewBeneficiary(stepNewBeneficiary + 1);
  };

  const onSubmitInfo = (values: InfoBeneficiary) => {
    if (!stepNewBeneficiary) return;
    setStepNewBeneficiary(stepNewBeneficiary + 1);
    setValueFormInfo(values);
  };

  const onSubmitWallet = (values: WalletBeneficiary) => {
    if (!stepNewBeneficiary) return;
    setStepNewBeneficiary(stepNewBeneficiary + 1);
    setValueFormWallet(values);
    setWalletSkip(false);
  };

  const onSubmitBank = async (values: any) => {
    if (!stepNewBeneficiary) return;
    setStepNewBeneficiary(stepNewBeneficiary + 1);
    setValueFormBank(values);
    setBankSkip(false);
  };

  const onSubmit = async () => {
    console.log('valueFormInfo...........', valueFormInfo);
    if (loadingCreateCompany) return;
    if (!valueFormInfo) return;
    const infoBody = {
      fullName: valueFormInfo.companyName || "",
      name: valueFormInfo.nickName || "",
      directorFirstName: valueFormInfo.directorFirstName || "",
      directorLastName: valueFormInfo.directorLastName || "",
      address1: valueFormInfo.address1 || "",
      address2: valueFormInfo.address2 || "",
      city: valueFormInfo.city || "",
      stateProvince: valueFormInfo.stateProvince || "",
      country: valueFormInfo.companyOfficiallyRegistered || "",
      tinVatUid: valueFormInfo.tinVatUid || "",
      regNo: valueFormInfo.regNo || "",
      phoneNumber1: valueFormInfo.phoneNumber1 || "",
      email: valueFormInfo.email || "",
      smartUID: valueFormInfo.smartUID
        ? valueFormInfo.smartUID?.trim()
        : undefined,
      website: valueFormInfo.website || "",
      postalCode: valueFormInfo.postalCode || "",
      refUserId: infoByUserCode?.id ? infoByUserCode?.id : undefined,
    };

    const companyWallet = {
      assetConfigGroupId: valueFormWallet?.currency || 0,
      networkId: valueFormWallet?.network || 0,
      address: valueFormWallet?.address || "",
      name: valueFormWallet?.name || "",
    };

    const bank = !valueFormBank?.bankId
      ? {
        name: valueFormBank?.bankName || "",
        swift: valueFormBank?.bankSwift || "",
        legalAddress: valueFormBank?.bankAddress || "",
        country: valueFormBank?.bankCountry || "",
      }
      : undefined;
    console.log('valueFormBank...........', valueFormBank);
    const bankAccount = {
      ...(valueFormBank?.bankId ? { bankId: valueFormBank?.bankId } : {}),
      currencyCode: valueFormBank?.currencyCode || "",
      abaRoutingNumber: valueFormBank?.abaRoutingNumber !== '' && valueFormBank?.abaRoutingNumber ? valueFormBank?.abaRoutingNumber : undefined,
      bankStateBranchNumber: valueFormBank?.bankStateBranchNumber !== '' && valueFormBank?.bankStateBranchNumber ? valueFormBank?.bankStateBranchNumber : undefined,
      branchNumber: valueFormBank?.branchNumber || "",
      accountNumber: valueFormBank?.accountNumber || "",
    };

    const companyBody = {
      ...infoBody,
      ...(valueFormWallet && !walletSkip ? { companyWallet } : {}),
      ...(valueFormBank && bank && !bankSkip ? { bank } : {}),
      ...(valueFormBank && !bankSkip ? { bankAccount } : {}),
    };
    createCompany(companyBody);
  };

  const onSubmitRemitter = (values: any) => {
    if (loadingCreateRemitter) return;
    const body = {
      fullName: values.companyName || "",
      name: values.nickName || "",
      directorFirstName: values.directorFirstName || "",
      directorLastName: values.directorLastName || "",
      address1: values.address1 || "",
      address2: values.address2 || "",
      city: values.city || "",
      stateProvince: values.stateProvince || "",
      country: values.companyOfficiallyRegistered || "",
      tinVatUid: values.tinVatUid || "",
      regNo: values.regNo || "",
      phoneNumber1: values.phoneNumber1 || "",
      email: values.email || "",
      smartUID: values.smartUID ? values.smartUID?.trim() : undefined,
      website: values.website || "",
      postalCode: values.postalCode || "",
      refUserId: infoByUserCodeRemitter?.id
        ? infoByUserCodeRemitter?.id
        : undefined,
    };
    createRemitter(body);
  };

  const handleChangeCountry = (value: string) => {
    setSearchCountry(value);
    setCurrentPage(1);
    setParams({
      start,
      end,
    });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setParams({
      start: (page - 1) * dataListCompany.pageSize || start,
      end: page * dataListCompany.pageSize || end,
    });
  };

  const handleCancelDelete = () => {
    setDeleteBeneficiaryId(null);
  };

  const handleSubmitDelete = () => {
    deleteCompany(deleteBeneficiaryId);
  };

  const columns = useMemo((): ColumnType<RowTable>[] => {
    const columns: ColumnType<RowTable>[] = [
      {
        dataIndex: "customId",
        title: <span className={"column-header"}>ID</span>,
        onCell: (record: RowTable) => ({
          onClick: () => navigate(`/beneficiaries/${record.id}`),
        }),
        render: (value, record: any) => {
          return (
            <Typography className="text-table">
              {record?.refUser?.smartUID || value}
            </Typography>
          );
        },
        width: "7.2%",
      },
      {
        dataIndex: "fullName",
        title: <span className={"column-header"}>NAME</span>,
        onCell: (record: RowTable) => ({
          onClick: () => navigate(`/beneficiaries/${record.id}`),
        }),
        render: (value) => {
          return <Typography className="text-table">{value}</Typography>;
        },
        width: "37.2%",
      },
      {
        dataIndex: "tinVatUid",
        title: <span className={"column-header"}>VAT/TIN/UID</span>,
        onCell: (record: RowTable) => ({
          onClick: () => navigate(`/beneficiaries/${record.id}`),
        }),
        width: "14.8%",
      },
      {
        dataIndex: "regNo",
        title: <span className={"column-header"}>RED</span>,
        onCell: (record: RowTable) => ({
          onClick: () => navigate(`/beneficiaries/${record.id}`),
        }),
        width: "14.8%",
      },
      {
        dataIndex: "country",
        title: <span className={"column-header"}>COUNTRY</span>,
        onCell: (record: RowTable) => ({
          onClick: () => navigate(`/beneficiaries/${record.id}`),
        }),
        render: (value) => {
          return <Typography className="text-table">{value}</Typography>;
        },
        width: "14.8%",
      },
      {
        title: <div></div>,
        render: (record: RowTable) => (
          <div className="action-table">
            {record.canBeDeleted && (
              <TrashIcon
                className="icon-animation"
                onClick={() => setDeleteBeneficiaryId(record.id)}
              />
            )}
            <PencilIcon
              className="icon-animation"
              onClick={() => navigate(`/beneficiaries/${record.id}`)}
            />
          </div>
        ),
      },
    ];
    return columns.filter(({ key }) => !key);
  }, []);

  useEffect(() => {
    setTitleHeader("Beneficiaries & Remitters Management");
  }, []);

  useEffect(() => {
    if (!show) return;
    if (show === "1") setStepNewBeneficiary(1);
  }, [show]);
  console.log('valueFormInfo..2.........', valueFormInfo);
  return (
    <div className="box-container">
      <CustomBreadCrumb breadCrumb={breadCrumb} showHome={true} />
      <div className="box-header">
        <div className="box-params">
          <SearchCustom
            value={searchName}
            placeholder="Search by name"
            onChange={handleSearch}
            onSubmit={handleSearch}
          />
          <Select
            showSearch
            clearIcon={<ClearIcon style={{ height: 12, width: 12 }} />}
            allowClear
            style={{ width: "150px" }}
            placeholder="All Countries"
            suffixIcon={searchCountry ? null : <ArrowIcon />}
            onChange={handleChangeCountry}
            optionLabelProp="label"
            filterOption={(input, option) => {
              const label = option?.label;
              if (typeof label === "string") {
                return label.toLowerCase().includes(input.toLowerCase());
              }
              return false;
            }}
          >
            {metadataCountries.map((item) => (
              <Select.Option
                key={item.value}
                value={item.value}
                label={item.label}
              >
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: 2,
                  }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                    }}
                  >
                    {item.label}
                  </span>
                  {searchCountry === item.value && (
                    <CheckSelectIcon style={{ flexShrink: 0 }} />
                  )}
                </span>
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="box-params">
          <CustomButton
            size={isTablet ? "small" : "medium"}
            text={"Add Beneficiary"}
            icon={<PlusIcon />}
            onClick={() => setStepNewBeneficiary(1)}
          />
          <CustomButton
            size={isTablet ? "small" : "medium"}
            text={"Add Remitter"}
            icon={<PlusIcon />}
            onClick={() => setModalRemitter(true)}
          />
        </div>
      </div>
      <Table
        className={`custom-ant-table custom-ant-table-beneficiary ${isLoading ? "table-hidden-empty" : ""
          }`}
        rowKey="id"
        rowClassName={() => "custom-table-row"}
        style={{ tableLayout: "auto" }}
        columns={columns as any}
        dataSource={dataListCompany.items}
        loading={isLoading}
        scroll={{ y: "calc(100vh - 295px)" }}
        pagination={{
          current: currentPage,
          total: dataListCompany.total,
          pageSize: dataListCompany.pageSize,
          onChange: handlePageChange,
          itemRender: (_page, type, element) => {
            switch (type) {
              case "prev":
                return (
                  <PrevPagination
                    currentPage={currentPage}
                    setCurrentPage={(page) => handlePageChange(page)}
                  />
                );
              case "next":
                return (
                  <NextPagination
                    totalPage={dataListCompany.totalPages}
                    currentPage={currentPage}
                    setCurrentPage={(page) => handlePageChange(page)}
                  />
                );
            }
            return element;
          },
        }}
      />
      <Modal
        open={!!stepNewBeneficiary}
        onCancel={handleCloseModalBeneficiary}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <TitleModal
            stepNewBeneficiary={stepNewBeneficiary}
            listStep={listStep}
            handleStep={handleStep}
            handleCloseModalBeneficiary={handleCloseModalBeneficiary}
          />
        }
        className="add-beneficiary-modal"
      >
        <div className="add-beneficiary-modal-body">
          <FormInfo
            onSubmitInfo={onSubmitInfo}
            stepNewBeneficiary={stepNewBeneficiary}
            metadataCountries={metadataCountries}
            valueFormInfo={valueFormInfo}
            setInfoByUserCode={setInfoByUserCode}
            infoByUserCode={infoByUserCode}
          />
          <FormWallet
            onSubmitWallet={onSubmitWallet}
            valueFormWallet={valueFormWallet}
            onBack={handleBack}
            onSkip={() => {
              setWalletSkip(true);
              handleSkip();
            }}
            stepNewBeneficiary={stepNewBeneficiary}
          />
          <FormBank
            onSubmitBank={onSubmitBank}
            valueFormBank={valueFormBank}
            onBack={handleBack}
            onSkip={() => {
              setBankSkip(true);
              handleSkip();
            }}
            bankSelected={bankSelected}
            setBankSelected={setBankSelected}
            stepNewBeneficiary={stepNewBeneficiary}
            metadataCountries={metadataCountries}
            metadataCurrency={metadataCurrency}
          />
          <FormConfirm
            onSubmit={onSubmit}
            onBack={handleBack}
            stepNewBeneficiary={stepNewBeneficiary}
            walletSkip={walletSkip}
            bankSkip={bankSkip}
            valueFormInfo={valueFormInfo}
            valueFormWallet={valueFormWallet}
            valueFormBank={valueFormBank}
            bankSelected={bankSelected}
            setStepNewBeneficiary={setStepNewBeneficiary}
            loadingCreateCompany={loadingCreateCompany}
          />
        </div>
      </Modal>
      <Modal
        open={!!modalRemitter}
        onCancel={handleCloseModalRemitter}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{
                fontSize: isTablet ? 16 : 20,
                fontWeight: 700,
                color: "#C2C6CE",
              }}
            >
              {"Add Remitter"}
            </Typography>
            <CloseIcon
              onClick={handleCloseModalRemitter}
              className="icon-animation"
            />
          </>
        }
        className="add-beneficiary-modal"
      >
        <div className="add-beneficiary-modal-body">
          <FormAddNewRemitter
            onSubmitInfo={onSubmitRemitter}
            metadataCountries={metadataCountries}
            setInfoByUserCode={setInfoByUserCodeRemitter}
            infoByUserCode={infoByUserCodeRemitter}
          />
        </div>
      </Modal>
      <ConfirmModal
        type="warning"
        title="Confirm Delete"
        description="Do you want to delete this record?"
        open={!!deleteBeneficiaryId}
        onCancel={handleCancelDelete}
        onSubmit={handleSubmitDelete}
        isLoading={loadingDelete}
      />
    </div>
  );
};
